import _ from 'lodash';
import Config from '../../AppConfig';
import { SearchFilterValues } from '../domains/searchFilters.domain';
import { get } from './core/fetch';
import { convertObjectToQs } from './convertObjectToQs';

export const getAdvancedSearchResults = async (
	adviserUUID: string,
	filters: any
): Promise<any> => {
	const encodedFilters = convertObjectToQs(filters);
	return await get(
		`${Config.mlcApiPrefix}/advisers/${adviserUUID}/customers?search=advanced&${encodedFilters}`,
		{
			withAuth: true,
			noGateway: false,
		}
	);
};

export const getSearchResultsCount = async (
	adviserUUID: string,
	filters: any
): Promise<any> => {
	const encodedFilters = convertObjectToQs(filters);
	return new Promise(async (resolve: Function, reject: Function) => {
		try {
			const response = await get(
				`${Config.mlcApiPrefix}/advisers/${adviserUUID}/customers?search=count${
					encodedFilters.length > 0 ? '&' : ''
				}${encodedFilters}`,
				{
					withAuth: true,
					noGateway: false,
				}
			);

			resolve(response);
		} catch (Error) {
			reject(Error);
		}
	});
};

export const PAGE_SIZE_PER_REQUEST = 5000;
export const MAX_REQUESTS_PER_BATCH = 4;

export function getSearchResultsForCSV(
	customerToken: string,
	totalCount: number,
	searchFilters: SearchFilterValues,
	maxPageSize: number = PAGE_SIZE_PER_REQUEST,
	maxRequestsPerBatch: number = MAX_REQUESTS_PER_BATCH
) {
	async function fetchResults(pageNumber: number) {
		const results = await getAdvancedSearchResults(customerToken, {
			...searchFilters,
			page: pageNumber,
			size: maxPageSize,
		});
		return results.items;
	}

	function getResultsForBatch(
		promiseArray: PromiseConstructor[],
		batch: number
	) {
		return new Promise((resolve, reject) => {
			Promise.all(
				_(promiseArray)
					.map((item, index: number) => {
						return fetchResults(batch * maxRequestsPerBatch + (index + 1));
					})
					.value()
			)
				.then(results => {
					const combinedResults = _(results)
						.map((page: any) => page.items)
						.flatten()
						.value();
					setTimeout(() => {
						resolve(combinedResults);
					}, 500);
				})
				.catch(() => {
					setTimeout(() => {
						reject();
					}, 500);
				});
		});
	}
	const totalRequestsNeeded = Math.ceil(totalCount / maxPageSize);
	const totalBatchesNeeded = Math.ceil(
		totalRequestsNeeded / maxRequestsPerBatch
	);

	let noOfRequestsLeft = totalRequestsNeeded;

	return new Promise(async (resolve, reject) => {
		try {
			// let batchedResponses = new Array(totalBatchesNeeded);
			// for (let i = 0; i < totalBatchesNeeded; i++) {
			// 	let promiseArray = new Array(
			// 		noOfRequestsLeft < maxRequestsPerBatch
			// 			? noOfRequestsLeft
			// 			: maxRequestsPerBatch
			// 	);
			// 	batchedResponses[i] = await getResultsForBatch(promiseArray, i);
			// 	noOfRequestsLeft = noOfRequestsLeft - maxRequestsPerBatch;
			// }

			const allResults = new Array(totalRequestsNeeded);
			for (let i = 0; i < totalRequestsNeeded; i++) {
				allResults[i] = await fetchResults(i + 1);
			}

			resolve(
				_(allResults)
					.flatten()
					.value()
			);
		} catch (Error) {
			reject();
		}
	});
}
